/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import {
  Paper, Box, Typography, Grid, Link, Stack,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { textoCadastro, Documentos } from '../../services/textos';
import { Usuario, AnexoUsuario } from '../models';
import { colors } from '../../services/colors';
import Input from '../../components/input';
import Stepper from '../../components/Stepper';
import Button from '../../components/Button/Button';
import LoadingFull from '../../components/LoadingFull';
import { LoginStore, LinksStore } from '../../services/zustandProvider';
import { postUser, putUser, getEmailDPO } from '../../services/loginAPI';

const paperSx = {
  backgroundColor: '#00838f !important',
  padding: '12px',
  // height: '335px',
};

const paperSxBranco = {
  backgroundColor: `${colors.themePrimary} !important`,
  padding: '18px',
};

const textSx = {
  fontSize: '22px',
};

const steps = [{
  label: 'Solicitação do cadastro',
  icon: null,
  ativo: false,
  passado: true,
},
{
  label: 'Confirmação do endereço de e-mail',
  icon: null,
  ativo: false,
  passado: true,
},
{
  label: 'Validação do documentos e foto',
  icon: null,
  ativo: true,
  passado: false,
},
{
  label: 'Acesso concedido',
  icon: null,
  ativo: false,
  passado: true,
},
];
export default function Cadastro():JSX.Element {
  const location = useLocation<any>();
  const [loading, setLoading] = useState(false);
  const { userAtivo, setUserAtivo } = LoginStore();
  const { setCadastroFinalizado, setLog } = LoginStore();
  const [dados, setDados] = useState<Usuario>(new Usuario());
  const [confirmarEmail, setConfirmarEmail] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const { LinkSite, LinkPoliticas } = LinksStore();
  const [dadosAnexo, setDadosAnexo] = useState<AnexoUsuario>(new AnexoUsuario());
  const [file1, setFile1] = useState<any>();
  const [file2, setFile2] = useState<any>();
  const [namefile1, setnameFile1] = useState<any>();
  const [namefile2, setnameFile2] = useState<any>();
  const [emailDPO, setEmailDPO] = useState<any>('');
  const [passo, setPasso] = useState(0);
  const [errorNome, setErroNome] = useState({
    status: false,
    massage: '',
  });
  const [errorEmail, setErroEmail] = useState({
    status: false,
    massage: '',
  });
  const [errorCpf, setErroCpf] = useState({
    status: false,
    massage: '',
  });
  const [errorSenha, setErroSenha] = useState({
    status: false,
    massage: '',
  });
  const [errorFile1, setErroFile1] = useState({
    status: false,
    massage: '',
  });
  const [errorFile2, setErroFile2] = useState({
    status: false,
    massage: '',
  });
  useEffect(() => {
    async function get() {
      setLoading(true);
      const getEmail = await getEmailDPO();
      setEmailDPO(getEmail?.dados?.email);
      setLog(true);
      if (location?.state?.emailCadastro) {
        setDados((prev) => ({ ...prev, email: location?.state?.emailCadastro }));
      } else {
        setnameFile1(userAtivo.anexosUsuario.copiaDocumentoFileName);
        setnameFile2(userAtivo.anexosUsuario.fotoComDocumentoFileName);
        setConfirmarSenha(userAtivo.senha);
        setDados(userAtivo);
        if (userAtivo.confirmarEmail !== 'Sim') {
          setPasso(1);
        } else if (userAtivo.confirmarDPO !== 'Sim') {
          setPasso(2);
        } else {
          setPasso(5);
        }
        setLoading(false);
      }
      setLoading(false);
    } get();
  }, [userAtivo]);
  function corfirmarSenha() {
    if (confirmarSenha === dados.senha) {
      return true;
    }
    setErroSenha({ status: true, massage: 'Senhas não conferem' });
    return false;
  }
  function FormatForm() {
    const imagefile1: any = document.querySelector('#file1');
    const imagefile2: any = document.querySelector('#file2');
    const formData = new FormData();
    formData.append('nome', dados.nome);
    formData.append('cpf', dados.cpf);
    formData.append('email', dados.email);
    formData.append('senha', dados.senha);
    formData.append('confirmarSenhaLocal', dados.senha);
    formData.append('copiaDocumento', imagefile1?.files[0]);
    formData.append('fotoComDocumento', imagefile2?.files[0]);
    return (formData);
  }
  function FormatFormUpdate() {
    const imagefile1: any = document.querySelector('#file1');
    const imagefile2: any = document.querySelector('#file2');
    const formData = new FormData();
    formData.append('nome', dados.nome);
    formData.append('cpf', dados.cpf);
    formData.append('email', dados.email);
    formData.append('senha', dados.senha);
    formData.append('confirmarSenhaLocal', dados.senha);
    formData.append('confirmarSenhaLocal', dados.senha);
    formData.append('usuarioId', dados.usuarioId);
    if (file1) {
      formData.append('copiaDocumento', imagefile1?.files[0]);
    }
    if (file2) {
      formData.append('fotoComDocumento', imagefile2?.files[0]);
    }
    return (formData);
  }
  function LimpezaMsgErro() {
    setErroNome({ status: false, massage: '' });
    setErroCpf({ status: false, massage: '' });
    setErroSenha({ status: false, massage: '' });
    setErroEmail({ status: false, massage: '' });
    setErroFile1({ status: false, massage: '' });
    setErroFile2({ status: false, massage: '' });
  }
  function Erros(formErros: any) {
    console.log('teste');
    formErros.forEach((e: any) => {
      if (e.propertyName === 'Nome') {
        setErroNome({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'CPF') {
        setErroCpf({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'Senha') {
        setErroSenha({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'Email') {
        setErroNome({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'CopiaDocumento') {
        setErroFile1({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'FotoComDocumento') {
        setErroFile2({ status: true, massage: e.errorMessage });
      }
    });
  }
  async function CadastrarUpdate() {
    if (corfirmarSenha()) {
      setLoading(true);
      const postForm = await putUser(FormatFormUpdate());
      setLoading(false);
      if (postForm.sucesso) {
        LimpezaMsgErro();
        localStorage.removeItem('ptt:User');
        localStorage.removeItem('ptt:Token');
        console.log(postForm.sucesso);
      } else {
        LimpezaMsgErro();
        Erros(postForm.erros);
      }
    }
  }
  async function Cadastrar() {
    if (corfirmarSenha()) {
      setLoading(true);
      const postForm = await postUser(FormatForm());
      setLoading(false);
      if (postForm.sucesso) {
        LimpezaMsgErro();
        console.log(postForm.sucesso);
        setPasso(1);
      } else {
        LimpezaMsgErro();
        Erros(postForm.erros);
      }
    }
  }
  return (
    <>
      <Box>
        <LoadingFull open={loading} />
        <Box sx={{
          marginBottom: '5px',
          marginTop: '5px',
        }}
        >
          <Typography sx={{ fontSize: '14px' }}>
            Olá! Seja bem-vindo
            <br />
            Para que você possa usar o Portal do Titular como canal de comunicação com o nosso DPO, precisamos confirmar alguns de seus dados e conferir a autenticidade do seu cadastro.
            <br />
            Para isso, preencha os dados a seguir e, na sequência, valide o link que iremos enviar para o seu e-mail. Depois disso, assim que nossa equipe validar a autenticidade de suas informações, você poderá navegar no Portal do Titular e gerenciar suas solicitações para nossa equipe de privacidade.
            Lembre-se que, enquanto seu cadastro não fica pronto, você ainda pode falar com nosso DPO através do e-mail
            {' '}
            <b>
              { emailDPO }
            </b>
            !
          </Typography>

          <Box sx={{
            margin: '3px',
            backgroundColor: colors.themeSecundary,
            width: '80%',
            height: 4,
            marginTop: '1px',
            marginBottom: '1px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          />
        </Box>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Paper sx={paperSx}>
              <Typography sx={textSx} align="right" color="white"> Seus dados </Typography>
              <Input
                required
                id="Nome"
                variant="outlined"
                labelSuperior="Nome"
                name="Nome"
                placeHolder="Nome"
                inputColor="white"
                autoFocus
                error={errorNome.status}
                mensagem={errorNome.massage}
                value={dados.nome}
                onChange={(e) => setDados((prev) => ({ ...prev, nome: e.target.value }))}
              />
              <Input
                required
                id="CPF"
                labelSuperior="CPF"
                name="cpf"
                placeHolder="CPF"
                inputColor="white"
                autoFocus
                fullWidth
                variant="outlined"
                error={errorCpf.status}
                value={dados.cpf}
                mensagem={errorCpf.massage}
                onChange={(e) => setDados((prev) => ({ ...prev, cpf: e.target.value }))}
              />
              <Input
                required
                id="E-mail"
                labelSuperior="E-mail"
                name="E-mail"
                placeHolder="E-mail"
                inputColor="white"
                autoFocus
                fullWidth
                variant="outlined"
                error={errorEmail.status}
                value={dados.email}
                mensagem={errorEmail.massage}
                onChange={(e) => setDados((prev) => ({ ...prev, email: e.target.value }))}
              />
              {/* <Input
              required
              id="ConfirmarE-mail"
              labelSuperior="Confirmar E-mail"
              name="E-mail"
              placeHolder="Cofirmar E-mail"
              inputColor="white"
              autoFocus
              fullWidth
              variant="outlined"
              error={false}
              value={confirmarEmail}
              mensagem=""
              onChange={(e) => setConfirmarEmail(e.target.value)}
            /> */}
              <Input
                required
                id="Senha"
                labelSuperior="Senha"
                name="Senha"
                type="password"
                placeHolder="Senha"
                inputColor="white"
                autoFocus
                fullWidth
                variant="outlined"
                error={errorSenha.status}
                value={dados.senha}
                mensagem={errorSenha.massage}
                onChange={(e) => setDados((prev) => ({ ...prev, senha: e.target.value }))}
              />
              <Input
                required
                id="ConfirmarSenha"
                labelSuperior="Confirmar senha"
                name="ConfirmarSenha"
                type="password"
                placeHolder="Confirmar senha"
                inputColor="white"
                autoFocus
                fullWidth
                variant="outlined"
                error={errorSenha.status}
                value={confirmarSenha}
                mensagem={errorSenha.massage}
                onChange={(e) => setConfirmarSenha(e.target.value)}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Paper sx={paperSx}>
              <Typography sx={textSx} align="right" color="white"> Seus documentos </Typography>
              { Documentos }
              <Input
                required
                id="file1"
                labelSuperior="Cópia do seu documento"
                name="Arquivo"
                placeHolder="Cópia do seu documento"
                inputColor="white"
                autoFocus
                fullWidth
                type="file"
                variant="outlined"
                nameFile={namefile1}
                error={errorFile1.status}
                value={file1}
                onChange={(e: any) => setFile1(e.target.value)}
                mensagem={errorFile1.massage}
              />
              <Input
                required
                id="file2"
                labelSuperior="Sua foto segurando seu documento"
                name="Arquivo2"
                placeHolder="Sua foto segurando seu documento"
                inputColor="white"
                autoFocus
                type="file"
                fullWidth
                nameFile={namefile2}
                variant="outlined"
                error={errorFile2.status}
                value={file2}
                onChange={(e: any) => setFile2(e.target.value)}
                mensagem={errorFile2.massage}
              />
            </Paper>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
              {
            passo === 0
              ? <Button variante="loading" cor="cyan" tonalidade={800} size="large" loading={loading} onClickLoading={() => Cadastrar()}>Cadastrar</Button>
              : <Button variante="loading" cor="cyan" tonalidade={800} size="large" loading={loading} onClickLoading={() => CadastrarUpdate()}>Atualizar cadastro</Button>
            }
            </Box>

          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Paper sx={paperSxBranco} elevation={0}>
              <Stepper steps={steps} ativo={passo} />
            </Paper>
          </Grid>
        </Grid>
        <Box sx={{ position: 'relative', bottom: { xs: '3px', sm: '25px' }, right: '2px' }}>
          <Typography sx={{ fontSize: '15px' }} align="right">
            Para maiores informações sobre LGPD, consulte
            {' '}
            <Link href={LinkSite} target="_blank">nossa página</Link>
            {' '}
            e
            {' '}
            <Link href={LinkPoliticas} target="_blank">nossa Política de Privacidade</Link>
          </Typography>
        </Box>
      </Box>
    </>
  );
}
